/**
 * @Author:
 * @Description:
 * @DateTime: Created in 2020-11-30 18:57:40
 */

import {Component} from 'vue-property-decorator'
import BasicSearchPage from "src/components/basicSearchPage/basicSearchPage";
import override from "src/dectorators/override";
import {SystemSetDOI} from "./api/systemSetApi";
import SystemSetService from "./service/systemSetService";
import './systemSet.less';
import { createNamespace } from 'src/util/bem';

@Component({name: 'system-set'})
export default class SystemSet extends BasicSearchPage<SystemSetService, SystemSetDOI.RowDataI, SystemSetDOI.QueryRowDataParamsI> {
    className=createNamespace('system-set')
    // checkBoxShow = true;

    @override
    renderHead(h) {
        return <div></div>
    }

	@override
	loadService () {
		this.service = new SystemSetService(this)
	}
}
